import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import {Button, Card, Grid} from "@mui/material";
import Select from "react-select";
import MiniMap from "./components/MiniMap";
import logo from './assets/logo.svg';
import LocationSelectForMain from "./components/LocationSelectForMain";
import {ContactEmergency, InfoTwoTone} from "@mui/icons-material";
import Header from "./components/Header";

export default function Contact() {



    return (

        <div className="App">
            <Header />
            <main>
                <p style={{
                    border: 'darkgrey 0px solid',
                    width: '99%',
                    borderRadius: '5px',
                    margin: '0 auto',
                    minHeight: '80px',
                    padding: '20px',
                    alignContent: 'center',
                }}><ContactEmergency color={'info'} fontSize={'large'}/>
                    <br/> <br/>
                    Bizimle <a href={'mailto:info@acilcocukdoktoru.com'}>info@acilcocukdoktoru.com</a> eposta adresiyle
                    iletişime geçebilirsiniz.
                </p>
                <p></p>

            </main>


            <footer>

                <div className="social-media-icons">
                    {/* Add social media icons here */}
                </div>
            </footer>

        </div>
    )
}
